var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    rate,
    loan_type,
    price,
    down_payment,
    lender,
    loan_amount_label,
    down_payment_label,
    loan_amount_hover_text,
    down_payment_hover_text
  } = options;

__p+='\n\n<div class="modal-content" role="document">\n      <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n        ';
 if (rate.phone_no) {
__p+='\n          <a href="tel:'+
((__t=( rate.phone_no ))==null?'':__t)+
'" data-omtag="finance:mortgage-rate-table:phone" class="btn btn-default btn-phone hidden-xs" data-phone-number="'+
((__t=( rate.phone_no ))==null?'':__t)+
'"><i class="ra ra-phone"></i> '+
((__t=( rate.phone_no ))==null?'':__t)+
'</a>\n        ';
}
__p+='\n        ';
 if (!rate.is_editorial) {
__p+='\n         <a href="'+
((__t=( rate.cpc_url ))==null?'':__t)+
'" class="btn btn-primary" data-omtag="finance:mortgage-rate-table:lender" target=\'_blank\' rel=\'nofollow\'>Next</a>\n        ';
}
__p+='\n      </div>\n      <div class="modal-body">\n        <h3>Offer Details</h3>\n        <ul class="margin-bottom-lg no-padding stripes">\n          <li><a role="button" data-toggle="popover" tabindex="99" data-trigger="focus"\n          data-placement="bottom" data-content="Reason for applying for a home loan, it’s either to purchase a new home or to refinance your existing home loan.">Loan purpose</a><span class="float-right">'+
((__t=( rate.purpose ))==null?'':__t)+
'</span></li>\n          <li><a role="button" data-toggle="popover" tabindex="100" data-trigger="focus"\n          data-placement="bottom" data-content="Lenders offer different loan programs. Common types of loan include 30-year fixed, 15-year fixed, and 5-year adjustable-rate mortgages (ARM). Your monthly mortgage payment will vary depending on the loan program you choose.">Loan type</a><span class="float-right">'+
((__t=( loan_type ))==null?'':__t)+
'</span></li>\n          <li><a role="button" data-toggle="popover" tabindex="101" data-trigger="focus"\n          data-placement="bottom" data-content="Mortgage rates are the rate of interest that is charged on a mortgage. Lenders determine the mortgage rates in most cases. Rates are fixed or variable, meaning that they either remain the same for the duration of the mortgage or vary depending on a benchmark interest rate.">Interest rate</a><span class="float-right">'+
((__t=( rate.rate.toFixed(3) ))==null?'':__t)+
'%</span></li>\n          <li><a role="button" data-toggle="popover" tabindex="102" data-trigger="focus"\n          data-placement="bottom" data-content="Points, also known as “discount points,” are fees paid directly to the lender at closing in exchange for a reduced interest rate. This is also called “buying down the rate,” which can, in turn, lower your monthly mortgage payments.">Points</a><span class="float-right">'+
((__t=( rate.points ))==null?'':__t)+
'</span></li>\n          <li><a role="button" data-toggle="popover" tabindex="103" data-trigger="focus"\n          data-placement="top" data-content="The annual percentage rate (APR) is a number designed to help you evaluate the total cost of a loan. In addition to the interest rate, it takes into account the fees, rebates, and other costs you may encounter over the life of the loan.">APR</a><span class="float-right">'+
((__t=( rate.apr_val.toFixed(3) ))==null?'':__t)+
'%</span></li>\n          <li><a role="button" data-toggle="popover" tabindex="104" data-trigger="focus"\n          data-placement="top" data-content="Monthly mortgage payment based on the loan amount, interest rate, and the amount of your down payment.">Payment (principal &amp; interest)</a><span class="float-right">'+
((__t=( MOVE.MORTGAGE.addDollarCommas(rate.loan_payment) ))==null?'':__t)+
'</span></li>\n          ';
 if (rate.cap !== '' && rate.cap !== undefined) { 
__p+='\n          <li><a role="button" data-toggle="popover" tabindex="105" data-trigger="focus"\n          data-placement="bottom" data-content="Eg. 2/2/5: The first two (Initial Cap) means that the most a rate can change is 2% the year after the fixed period expires. The second two (Subsequent Cap) means that the rate can change 2% every year thereafter, and the five (Lifetime Cap) means the maximum percentage that can be added to the initial rate for the lifetime of the loan.">Caps</a><span class="float-right">'+
((__t=( rate.cap ))==null?'':__t)+
'</span></li>\n          ';
 } 
__p+='\n          <li><a role="button" data-toggle="popover" tabindex="106" data-trigger="focus"\n          data-placement="top" data-content="'+
((__t=( loan_amount_hover_text ))==null?'':__t)+
'">'+
((__t=( loan_amount_label ))==null?'':__t)+
'</a><span class="float-right">'+
((__t=( MOVE.MORTGAGE.addDollarCommas(price - down_payment)))==null?'':__t)+
'</span></li>\n          <li><a role="button" data-toggle="popover" tabindex="107" data-trigger="focus"\n          data-placement="top" data-content="'+
((__t=( down_payment_hover_text ))==null?'':__t)+
'">'+
((__t=( down_payment_label ))==null?'':__t)+
'</a><span class="float-right">'+
((__t=( MOVE.MORTGAGE.addDollarCommas(down_payment) ))==null?'':__t)+
'</span></li>\n          <li><a role="button" data-toggle="popover" tabindex="108" data-trigger="focus"\n          data-placement="top" data-content="This includes several fees one needs to pay as part of getting a mortgage loan. Fees include things like application fee, rate lock fee, underwriting fee and loan processing fee.">Lender fees</a><span class="float-right">'+
((__t=( MOVE.MORTGAGE.addDollarCommas(rate.loan_fees) ))==null?'':__t)+
'</span></li>\n          ';
 if (rate.svy_date !== '' && rate.svy_date !== undefined) {
__p+='\n          <li><span>Date submitted<span class="float-right">'+
((__t=( MOVE.DateFormat.getFormattedDate(new Date(rate.svy_date)) ))==null?'':__t)+
'</span></li>\n          ';
 } 
__p+='\n          <li><a role="button" data-toggle="popover" tabindex="109" data-trigger="focus"\n          data-placement="top" data-content="This is the maximum duration between now and closing when the offered rate won’t change, as long as you close within the specified timeframe and there are no changes to your application. Rate locks are typically available for 30, 45, or 60 days, and sometimes longer.">Assumed rate lock</a><span class="float-right">'+
((__t=( rate.lock_period ))==null?'':__t)+
' days</span></li>\n        </ul>\n        <span class="muted">3rd party fees may apply</span>\n\n        <ul class="lender-info margin-bottom-lg margin-top no-padding">\n          ';
 if (_.contains(rate.features, 'bbb')) { 
__p+='\n          <li> <span class="item">BBB</span> Better Business Bureau Accredited</li>\n          ';
 } 
__p+='\n          ';
 if (_.contains(rate.features, 'low_fees')) { 
__p+='\n          <li> <span class="item">LOW</span> Low Fees</li>\n          ';
 } 
__p+='\n          ';
 if (_.contains(rate.features, 'fha')) { 
__p+='\n          <li> <span class="item">FHA</span> FHA Approved Lender</li>\n          ';
 } 
__p+='\n          ';
 if (_.contains(rate.features, 'va')) { 
__p+='\n          <li> <span class="item">VA</span> VA Approved Lender</li>\n          ';
 } 
__p+='\n        </ul>\n      </div>\n    </div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage/rate_table_detail_mobile.jst.ejs